'use strict';

exports.__esModule = true;
exports.default = createHttpReducer;

var _actionHelpers = require('./actionHelpers');

var _ramda = require('ramda');

var _asyncHelpers = require('./asyncHelpers');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function createHttpReducer(actionName) {
  var defaultState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var customReducer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var defaultReducer = function defaultReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _defineProperty({}, _asyncHelpers.defaultKey, defaultState);
    var _ref = arguments[1];
    var type = _ref.type,
        payload = _ref.payload,
        params = _ref.params,
        _ref$attrs = _ref.attrs,
        attrs = _ref$attrs === undefined ? {} : _ref$attrs,
        requestAction = _ref.requestAction;
    var path = (0, _asyncHelpers.getPath)((0, _ramda.pathOr)(params || _asyncHelpers.noParamsKey, ['params'], requestAction));

    var getState = function getState(payload) {
      return (0, _ramda.assoc)(path, payload, state);
    };

    switch (type) {
      case (0, _actionHelpers.toSuccess)(actionName):
        return getState(payload);

      case (0, _actionHelpers.toReset)(actionName):
        return (0, _ramda.omit)([path], state);

      case (0, _actionHelpers.toLoad)(actionName):
        return !state[path] || attrs.force ? getState(payload) : state;

      default:
        return state;
    }
  };

  if (customReducer) {
    return function (state, action) {
      return customReducer(state, action, defaultReducer);
    };
  }

  return defaultReducer;
}